import axios from "axios";
import { setLoader } from "../reusable_components/Loader";


async function patchData(url, formData, errorHandler, cb) {
    setLoader(true)
    try {
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        const { data } = await axios.patch(url, formData, { headers });
        
        if(cb !== null && cb !== undefined) {
            cb(data)
        } else {
            return data
        }
    } catch (error) {
        errorHandler(error);
    } finally {
        setLoader(false)
    }
}

export default patchData;